export const ROWS_PER_PAGE = 10;
export const LAB_TOKEN = process.env.REACT_APP_LAB_TOKEN ?? '';
export const PATIENT_TOKEN = process.env.REACT_APP_PATIENT_TOKEN ?? '';
export * from './api';
export * from './settings';